import { LandlordTiles } from "./landlord-tiles";

export const LandlordContainer = ({ companies }) => {

    return (
        <div className={'pos-customer bg-gray-100'} >
            <div className="pos-content">
                <div className="pos-content-container" options={{ suppressScrollX: true }}>
                    <div className="product-row">
                        <LandlordTiles companies={companies} />
                    </div>
                </div>
            </div>
        </div>
    );
};